if (!customElements.get('fe-night-gallery')) {
  customElements.define('fe-night-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this.events) return;
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      const finePointer = matchMedia('(min-width: 768px) and (hover: hover) and (pointer: fine)');
      this.querySelectorAll('.n-cards__row').forEach((row) => {
        const panels = [...row.querySelectorAll('[data-panel]')];
        if (!panels.length) return;
        const buttons = panels.map((p) => p.querySelector('.n-card__toggle'));
        let committed = panels[0];
        const activate = (panel) => panels.forEach((item) => {
          const open = item === panel;
          item.classList.toggle('is-active', open);
          item.querySelector('.n-card__toggle').setAttribute('aria-expanded', String(open));
          const details = item.querySelector('.n-card__details');
          details.inert = !open;
          details.setAttribute('aria-hidden', String(!open));
        });
        panels.forEach((panel, i) => {
          const button = buttons[i];
          button.hidden = panels.length < 2;
          button.addEventListener('click', () => { committed = panel; activate(panel); }, options);
          panel.addEventListener('pointerenter', (e) => {
            if (finePointer.matches && e.pointerType === 'mouse' && !row.contains(document.activeElement)) activate(panel);
          }, options);
          button.addEventListener('keydown', (e) => {
            const step = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 };
            let next;
            if (e.key === 'Home') next = 0;
            else if (e.key === 'End') next = buttons.length - 1;
            else if (e.key in step) next = (i + step[e.key] + buttons.length) % buttons.length;
            else return;
            e.preventDefault();
            committed = panels[next];
            activate(committed);
            buttons[next].focus();
          }, options);
        });
        row.addEventListener('pointerleave', () => activate(committed), options);
        activate(committed);
      });
      this.classList.add('is-ready');
    }
    disconnectedCallback() {
      queueMicrotask(() => { if (!this.isConnected) { this.events?.abort(); this.events = null; } });
    }
  });
}


(() => {
 const setup = (scope) => {
  scope.querySelectorAll('.fe-night [data-tabs]').forEach(root=>{
   if(root.dataset.bound)return;root.dataset.bound='true';
   const tabs=[...root.querySelectorAll('[role="tab"]')];
   const select=(tab,focus=false)=>{tabs.forEach(t=>{const on=t===tab;t.setAttribute('aria-selected',String(on));t.tabIndex=on?0:-1;root.querySelector('#'+CSS.escape(t.getAttribute('aria-controls'))).hidden=!on;});if(focus)tab.focus();};
   tabs.forEach((tab,i)=>{tab.addEventListener('click',()=>select(tab));tab.addEventListener('keydown',e=>{let n;if(e.key==='Home')n=0;else if(e.key==='End')n=tabs.length-1;else if(['ArrowRight','ArrowDown','ArrowLeft','ArrowUp'].includes(e.key))n=(i+(['ArrowRight','ArrowDown'].includes(e.key)?1:-1)+tabs.length)%tabs.length;else return;e.preventDefault();select(tabs[n],true);});});
  });
  scope.querySelectorAll('.fe-night .n-compare').forEach(root=>{
   if(root.dataset.bound)return;root.dataset.bound='true';
   const table=root.querySelector('.n-compare__table'),buttons=[...root.querySelectorAll('.n-compare__switch button')];
   buttons.forEach((b,i)=>{b.setAttribute('role','button');b.removeAttribute('aria-selected');b.setAttribute('aria-pressed',String(b.dataset.col===table.dataset.active));b.addEventListener('click',()=>{buttons.forEach(x=>x.setAttribute('aria-pressed',String(x===b)));table.dataset.active=b.dataset.col;});});
   root.querySelector('.n-compare__switch').setAttribute('role','group');
  });
 };
 setup(document);document.addEventListener('shopify:section:load',e=>setup(e.target));
})();
